import PropTypes from "prop-types"
import React, { useMemo, useRef } from "react"
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Label,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import classNames from "classnames"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

//i18n
import { useTranslation, withTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import Switch from "components/Shared/Switch"
import ReactApexChart from "react-apexcharts"
import {
  getDashboardKpi,
  getDashboardKpiOrder,
} from "store/actions/dashboardAction"
import { Bar, Pie } from "react-chartjs-2"
import "chart.js/auto"
import { ShimmerThumbnail } from "react-shimmer-effects"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"
import TableShimmer from "components/Shared/TableShimmer"
import { DateRangePicker, DatePicker } from "rsuite"
import "rsuite/dist/rsuite.min.css"
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  subDays,
  subMonths,
  format,
} from "date-fns"
import { getAllCityList } from "store/actions/cityAction"
import { getAllRegionList } from "store/actions/regionAction"
import Select from "components/Shared/TranslatedSelect"
import { allOption, timesUTC } from "components/Common/constants"
import { formatLocale12HourTime } from "components/Shared/localeDateTime"
import Bookings from "./Bookings"
import isPermissionEnabled from "common/isPermissionEnabled"
import BranchRatings from "./BranchRatings"
import CommonDateFilter from "./CommonDateFilter"
import { getBranchCountryList } from "store/actions/commonAction"
import { getAllGiftCardCategoriesWithoutPagination } from "store/actions/giftCardCategoriesAction"
import GiftCard from "./GiftCard"
import Wallet from "./Wallet"
import { getBrandList } from "store/actions/brandsAction"
import EStore from "./estore/EStore"
import { useBrandOptions } from "hooks"
import Marketing from "./marketing/Marketing"
import LoyaltyPoints from "./loyaltyPoints/LoyaltyPoints"
import useCrossModuleFilterPermissions from "hooks/useCrossModuleFilterPermissions"

const giftCardListSelectStyles = {
  control: provided => ({
    ...provided,
    minHeight: 38,
  }),
  valueContainer: provided => ({
    ...provided,
    flexWrap: "nowrap",
    overflowX: "auto",
    overflowY: "hidden",
  }),
  multiValue: provided => ({
    ...provided,
    flex: "0 0 auto",
  }),
}

const DASHBOARD_SELECT_MENU_PROPS = {
  menuPortalTarget: typeof document !== "undefined" ? document.body : null,
  menuPosition: "fixed",
}

const dashboardSelectMenuStyles = {
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: base => ({ ...base, zIndex: 9999 }),
}

const Dashboard = props => {
  const {
    i18n: { language },
  } = useTranslation()

  document.title = props.t("Dashboard ")

  const urlParams = new URLSearchParams(window.location.search)
  const tabValue = urlParams.get("tab") || "Gift Card"

  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(today.getDate() - 1)

  const startOfCurrentWeek = startOfWeek(today, { weekStartsOn: 0 }) // Monday as start of the week
  const endOfCurrentWeek = endOfWeek(today, { weekStartsOn: 0 })

  const previousWeekStartDate = subDays(startOfCurrentWeek, 7)
  const previousWeekEndDate = subDays(endOfCurrentWeek, 7)

  const startOfMonthDate = startOfMonth(today)
  const endOfMonthDate = endOfMonth(today)

  const previousMonthStartDate = startOfMonth(subMonths(today, 1))
  const previousMonthEndDate = endOfMonth(subMonths(today, 1))

  const [tabs, setTabs] = useState(tabValue)
  const [periodType, setPeriodType] = useState("day")
  const [commonDayType, setCommonDayType] = useState("day")
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { canFilterByBranch, canFilterByRegion, canFilterByCity } =
    useCrossModuleFilterPermissions()
  const [isLoading, setIsLoading] = useState(true)

  const [modalOpen, setModalOpen] = useState(false)
  const [country, setCountry] = useState([])
  const [region, setRegion] = useState([])
  const [city, setCity] = useState([])
  const [branches, setBranches] = useState([])
  const [selectedBranches, setSelectedBranches] = useState([])
  const [selectedBrand, setSelectedBrand] = useState([])
  const [selectedCountry, setSelectedCountry] = useState([])
  const [selectedRegion, setSelectedRegion] = useState([])
  const [selectedCity, setSelectedCity] = useState([])
  const [bookingModal, setBookingModal] = useState(false)
  const [ratingModal, setRatingModal] = useState(false)
  const [bookingType, setBookingType] = useState([])
  const [ratingBranches, setRatingBranches] = useState([])
  const [giftCardId, setGiftCardId] = useState([])
  const [categoryId, setCategoryId] = useState(null)
  const childFunctionRef = useRef(null)
  const ratingFunRef = useRef(null)
  const [usersPermissions, setUsersPermissions] = useState({
    isEidiyah: null,
    isSales: null,
    isBranches: null,
    isBookings: null,
    isRatings: null,
    isWallet: null,
    isEstore: null,
    isMarketing: null,
    isLoyalty: null,
  })

  const allowedDashboardTabs = useMemo(() => {
    const tabsList = []
    if (usersPermissions.isEidiyah) tabsList.push("Gift Card")
    if (usersPermissions.isSales) tabsList.push("sales")
    if (usersPermissions.isBranches) tabsList.push("branches")
    if (usersPermissions.isRatings) tabsList.push("ratings")
    if (usersPermissions.isBookings) tabsList.push("bookings")
    if (usersPermissions.isWallet) tabsList.push("wallet")
    if (usersPermissions.isEstore) tabsList.push("estore")
    if (usersPermissions.isMarketing) tabsList.push("marketing")
    if (usersPermissions.isLoyalty) tabsList.push("loyalty")
    return tabsList
  }, [usersPermissions])
  const { allowedBrands } = useBrandOptions()

  // const { brandList } = useSelector(state => state.Brands)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const { branchsList, countryList } = useSelector(state => state.Common)
  const { regionList } = useSelector(state => state.Region)
  const { cityList } = useSelector(state => state.City)
  const { giftCardList } = useSelector(state => state.GiftCard)
  const { categories } = useSelector(state => state.GiftCardCategories)

  const getDashboardData = () => {
    // Only fetch if user has Sales permission
    if (!usersPermissions.isSales) return
    
    const countryValue = country.value ? [country.value] : []
    const regionValue = region.value ? [region.value] : []
    const cityValue = city.value ? [city.value] : []

    setIsLoading(true)

    const payload = {
      type: periodType, //day , month, week
      isCompared: periodType === "custom" ? false : isCompared,
      branches,
      brand: selectedBrand?.value || "",
      date,
      comparisonDate,
      dateRange: periodType === "custom" ? customDateRange : dateRange,
      comparisonDateRange:
        periodType === "custom"
          ? comparisonCustomDateRange
          : comparisonDateRange,
      cities: cityValue,
      regions: regionValue,
      countries: countryValue,
    }
    dispatch(getDashboardKpi(payload))
  }

  const getDashboardOrderData = () => {
    // Only fetch if user has Branches permission
    if (!usersPermissions.isBranches) return
    
    const countryValue = country.value ? [country.value] : []
    const regionValue = region.value ? [region.value] : []
    const cityValue = city.value ? [region.value] : []

    const payload = {
      dateRange: commonDateRange,
      branches,
      cities: cityValue,
      regions: regionValue,
      countries: countryValue,
    }
    dispatch(getDashboardKpiOrder(payload))
  }

  // useEffect(() => {
  //   dispatch(getBrandList())
  // }, [])
  useEffect(() => {
    fetchBranchCountryList()
    // Only fetch gift card categories if user has Eidiyah permission
    if (usersPermissions.isEidiyah) {
      dispatch(getAllGiftCardCategoriesWithoutPagination())
    }
  }, [usersPermissions.isEidiyah])

  const fetchBranchCountryList = () => {
    if (!canFilterByBranch) return
    dispatch(getBranchCountryList())
  }

  const fetchRegionList = countryId => {
    if (!canFilterByRegion) return
    dispatch(getAllRegionList(countryId))
  }

  const fetchCityList = (countryId, regionId) => {
    if (!canFilterByCity) return
    const payload = {
      countryId,
      regionId,
    }
    dispatch(getAllCityList(payload))
  }

  const handleTabClick = tab => {
    if (!allowedDashboardTabs.includes(tab)) {
      return
    }
    setIsAllSelected(false)
    setSelectedBranches([])
    setBranches([])
    setCountry([])
    setRegion([])
    setCity([])
    setSelectedCountry([])
    setSelectedRegion([])
    setSelectedCity([])
    setSelectedBrand(null)
    // Keep periodType / commonDayType / date filters so selection persists across tabs
    setTabs(tab)
    navigate(`/dashboard?tab=${tab}`)
  }

  const convertTimeToUTCDate = timeString => {
    const [time, period] = timeString.split(" ")
    let [hours, minutes] = time.split(":")

    // Default minutes to 0 if not provided
    minutes = minutes || "00"

    // Handle AM/PM conversion
    hours = parseInt(hours, 10)
    if (period === "PM" && hours !== 12) {
      hours += 12
    } else if (period === "AM" && hours === 12) {
      hours = 0
    }
    // Create a new Date object with the UTC time
    const date = new Date(Date.UTC(2024, 0, 1, hours, minutes, 0))
    return date
  }

  const convertToLocaleTime = utcDate =>
    formatLocale12HourTime(utcDate, { padHour: true })

  const convertTimesArrayToLocale = timesArray => {
    return timesArray.map(time =>
      convertToLocaleTime(convertTimeToUTCDate(time))
    )
  }

  // CONVERT DATE TO LOCAL DATE
  const convertDateToUTC = dateString => {
    const [year, month, day] = dateString.split("-").map(Number)
    // Create a new Date object with the UTC date
    const date = new Date(Date.UTC(year, month - 1, day))
    return date
  }

  const convertToLocaleDate = utcDate => {
    // Get the date in local timezone and format it as YYYY-MM-DD
    const localDate = new Date(
      utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
    )
    return localDate?.toISOString()?.split("T")[0]
  }

  const convertDatesArrayToLocale = datesArray => {
    return datesArray?.map(date => convertToLocaleDate(convertDateToUTC(date)))
  }

  const formatDate = date => {
    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, "0")
    const day = date.getDate().toString().padStart(2, "0")
    const hours = date?.getHours()?.toString()?.padStart(2, "0")
    const minutes = date?.getMinutes()?.toString()?.padStart(2, "0")
    return `${year}-${month}-${day} ${hours}:${minutes}`
  }

  const formattedToday = formatDate(today)
  // Format yesterday's date as "YYYY-MM-DD"
  const formattedYesterday = formatDate(yesterday)

  // DEFAULT WEEK DAY
  const formattedStartOfCurrentWeek = formatDate(startOfCurrentWeek)
  const formattedEndOfCurrentWeek = formatDate(endOfCurrentWeek)
  const formattedPreviousWeekStartDate = formatDate(previousWeekStartDate)
  const formattedPreviousWeekEndDate = formatDate(previousWeekEndDate)

  const formattedStartOfMonth = formatDate(startOfMonthDate)
  const formattedEndOfMonth = formatDate(endOfMonthDate)
  const formattedPreviousMonthStartDate = formatDate(previousMonthStartDate)
  const formattedPreviousMonthEndDate = formatDate(previousMonthEndDate)

  const formattedBrands = useMemo(() => {
    return allowedBrands?.map(brand => {
      return {
        label: brand.brandName,
        // Use brand id so dashboard KPIs can filter by order.brandId
        // (serviceProvider is often null under dynamic branding).
        value: brand._id || brand.integration,
      }
    })
  }, [allowedBrands])

  const [isCompared, setIsCompared] = useState(false)
  const [date, setDate] = useState(formattedToday)
  const [dateRange, setDateRange] = useState({
    start: formattedStartOfCurrentWeek,
    end: formattedEndOfCurrentWeek,
  })

  const [commonDateRange, setCommonDateRange] = useState({
    start: formattedToday,
    end: formattedToday,
  })

  const [comparisonDateRange, setComparisonDateRange] = useState({
    start: formattedPreviousWeekStartDate,
    end: formattedPreviousWeekEndDate,
  })
  const [customDateRange, setCustomDateRange] = useState({
    start: formattedYesterday,
    end: formattedToday,
  })
  const [comparisonCustomDateRange, setComparisonCustomDateRange] = useState({
    start: formattedYesterday,
    end: formattedToday,
  })

  useEffect(() => {
    if (isCompared) {
      if (commonDayType === "week") {
        setComparisonDateRange({
          start: formattedPreviousWeekStartDate,
          end: formattedPreviousWeekEndDate,
        })
      } else if (commonDayType === "month") {
        setComparisonDateRange({
          start: formattedPreviousMonthStartDate,
          end: formattedPreviousMonthEndDate,
        })
      }
    }
  }, [isCompared, commonDayType])

  const [comparisonDate, setComparisonDate] = useState(formattedYesterday)

  useEffect(() => {
    // console.log("2")
    if (tabs !== "Gift Card") {
      tabs === "sales" && !isCompared && getDashboardData()
    }
  }, [
    // isCompared,
    comparisonDate,
    periodType,
    tabs,
    date,
    dateRange,
    branches,
    // customDateRange,
    // comparisonDateRange,
  ])

  useEffect(() => {
    tabs === "branches" && getDashboardOrderData()
  }, [tabs, commonDateRange, country, region, city, branches])

  useEffect(() => {
    // console.log("1")
    if (tabs !== "Gift Card") {
      tabs === "sales" && getDashboardData()
    }
  }, [
    // periodType,
    date,
    isCompared,
    comparisonDateRange,
    branches,
    comparisonDate,
    customDateRange,
    comparisonCustomDateRange,
  ])

  useEffect(() => {
    if (isCompared && periodType === "day" && tabs !== "Gift Card") {
      getDashboardData()
    }
  }, [isCompared, periodType])

  const { userRole, accountType } = useSelector(state => state.Login)
  const { loading, dashboardData, dashboardOrderData } = useSelector(
    state => state.Dashboard
  )



  useEffect(() => {
    const isEidiyahPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_5",
      accountType
    )
    const isSalesPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_1",
      accountType
    )
    const isBranchesPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_2",
      accountType
    )
    const isBookingsPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_3",
      accountType
    )
    const isRatingsPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_4",
      accountType
    )
    const isEstorePermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_6",
      accountType
    )
    const isMarketingPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_7",
      accountType
    )
    const isWalletPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_8",
      accountType
    )
    const isLoyaltyPermission = isPermissionEnabled(
      userRole,
      1,
      "dashboard_9",
      accountType
    )
    setUsersPermissions({
      isEidiyah: isEidiyahPermission,
      isSales: isSalesPermission,
      isBranches: isBranchesPermission,
      isBookings: isBookingsPermission,
      isRatings: isRatingsPermission,
      isWallet: isWalletPermission,
      isEstore: isEstorePermission,
      isMarketing: isMarketingPermission,
      isLoyalty: isLoyaltyPermission,
    })

  }, [userRole, accountType])

  useEffect(() => {
    if (!allowedDashboardTabs.length) {
      return
    }
    const searchParams = new URLSearchParams(window.location.search)
    const requestedTab = searchParams.get("tab")

    // If ?tab is missing (e.g. accidental query wipe), keep the current tab.
    if (!requestedTab) {
      if (allowedDashboardTabs.includes(tabs)) {
        navigate(`/dashboard?tab=${tabs}`, { replace: true })
        return
      }
      const fallbackTab = allowedDashboardTabs[0]
      if (tabs !== fallbackTab) {
        setTabs(fallbackTab)
        navigate(`/dashboard?tab=${fallbackTab}`, { replace: true })
      }
      return
    }

    const nextTab = allowedDashboardTabs.includes(requestedTab)
      ? requestedTab
      : allowedDashboardTabs[0]
    if (tabs !== nextTab) {
      setTabs(nextTab)
      navigate(`/dashboard?tab=${nextTab}`, { replace: true })
    }
  }, [allowedDashboardTabs, tabValue, tabs, navigate])

  useEffect(() => {
    console.log("usersPermissions", usersPermissions)
  }, [usersPermissions])
  useEffect(() => {
    checkPermissions(userRole?.permissions, 1, accountType)
  }, [])

  const handleBranchFilter = () => {
    const branchIds = selectedBranches?.map(branch => branch.value)
    setBranches(branchIds)
    setCountry(selectedCountry)
    setRegion(selectedRegion)
    setCity(selectedCity)
    toggleModal()
  }

  const routesMapping = {
    inAppContent_1: "/banners",
    roles_1: "/roles",
    menus_1: "/menus/categories",
    branchLocations_1: "/branches",
    usersPermission_1: "/users",
    customersPermission_1: "/customers",
    feedback_1: "#",
    order_1: "/f&b-orders",
    curbside_1: "#",
    country_1: "/countries",
  }

  const checkPermissions = (permissions, idToCheck) => {
    const firstEnabledPermission = permissions?.reduce((acc, role) => {
      if (!acc) {
        const enabledPermission = role.permissions.find(
          p => p.value === "view" && p.isEnabled
        )
        if (enabledPermission) {
          acc = enabledPermission
        }
      }
      return acc
    }, null)

    // console.log(firstEnabledPermission)
    if (firstEnabledPermission) {
      let p = firstEnabledPermission
      const route = routesMapping[p.id]
      if (route) {
        navigate(route)
      } else {
        console.log("url not found")
      }
    }
  }

  const toDayOnly = value => {
    if (!value) return value
    return String(value).split(" ")[0]
  }

  const buildDayRange = dayValue => {
    const day = toDayOnly(dayValue)
    return {
      start: `${day} 00:00`,
      end: `${day} 23:59`,
    }
  }

  // Keep Sales (`date`/`dateRange`/`customDateRange`) and other tabs
  // (`commonDateRange`) on the same selected filter.
  const syncSharedDateFilter = (range, dayType = commonDayType) => {
    if (!range?.start || !range?.end) return
    setCommonDateRange(range)
    if (dayType === "day") {
      setDate(toDayOnly(range.start))
    } else if (dayType === "week" || dayType === "month") {
      setDateRange(range)
      setPeriodType(dayType)
    } else if (dayType === "custom") {
      setCustomDateRange(range)
      setPeriodType("custom")
    }
  }

  const onChangeChartPeriod = (pType, type) => {
    // If the same type is already selected, do nothing
    if (type === commonDayType) {
      return
    }

    setPeriodType(pType)
    setCommonDayType(type)
    if (type === "day") {
      const range = buildDayRange(formattedToday)
      setDate(toDayOnly(formattedToday))
      setCommonDateRange(range)
    } else if (type === "week") {
      const range = {
        start: formattedStartOfCurrentWeek,
        end: formattedEndOfCurrentWeek,
      }
      setDateRange(range)
      setCommonDateRange(range)
    } else if (type === "month") {
      const range = {
        start: formattedStartOfMonth,
        end: formattedEndOfMonth,
      }
      setDateRange(range)
      setCommonDateRange(range)
    } else if (type === "custom") {
      setIsCompared(false)
      const range = {
        start: formattedYesterday,
        end: formattedToday,
      }
      setCustomDateRange(range)
      setCommonDateRange(range)
    }
  }

  const handleOnDateChange = (selectedDates, type) => {
    const formattedDate = `${selectedDates.getFullYear()}-${(
      selectedDates.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${selectedDates.getDate().toString().padStart(2, "0")}`

    if (type === "day") {
      setDate(formattedDate)
      setCommonDateRange(buildDayRange(formattedDate))
    } else if (type === "comparisonDate") {
      setComparisonDate(formattedDate)
    }
  }

  const handleDateRangeChange = value => {
    const range = {
      start: formatDate(value[0]),
      end: formatDate(value[1]),
    }
    setDateRange(range)
    setCommonDateRange(range)
  }

  const handleCustomDateRangeChange = value => {
    const range = {
      start: formatDate(value[0]),
      end: formatDate(value[1]),
    }
    setCustomDateRange(range)
    setCommonDateRange(range)
  }

  const handleComparisonDateRangeChange = value => {
    setComparisonDateRange({
      start: formatDate(value[0]),
      end: formatDate(value[1]),
    })
  }

  const handleCommonDateRangeChange = range => {
    syncSharedDateFilter(range, commonDayType)
  }

  const handleCommonDayTypeChange = type => {
    if (type === commonDayType) {
      return
    }
    setCommonDayType(type)
    setPeriodType(type === "custom" ? "custom" : type)
    if (type === "day") {
      syncSharedDateFilter(buildDayRange(formattedToday), "day")
    } else if (type === "week") {
      syncSharedDateFilter(
        {
          start: formattedStartOfCurrentWeek,
          end: formattedEndOfCurrentWeek,
        },
        "week"
      )
    } else if (type === "month") {
      syncSharedDateFilter(
        {
          start: formattedStartOfMonth,
          end: formattedEndOfMonth,
        },
        "month"
      )
    } else if (type === "custom") {
      setIsCompared(false)
      syncSharedDateFilter(
        {
          start: formattedYesterday,
          end: formattedToday,
        },
        "custom"
      )
    }
  }

  const [options, setOptions] = useState({
    chart: {
      id: "line-chart",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: 2,
      curve: "smooth",
    },
    legend: {
      show: true,
    },
    xaxis: {
      categories: [],
      type: "category",
    },
  })

  const [orderBranchData, setOrderBranchData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })

  const [comparisonOrderBranchData, setComparisonOrderBranchData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })

  const [mostOrderedItemsData, setMostOrderedItemsData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })
  const [comparisonMostOrderedItemsData, setComparisonMostOrderedItemsData] =
    useState({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
        },
      ],
    })

  const [mostPaymentMethodData, setMostPaymentMethodData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })
  const [comparisonMostPaymentMethodData, setComparisonMostPaymentMethodData] =
    useState({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
        },
      ],
    })

  const [orderSeries, setOrderSeries] = useState([])
  const [revenueByCountryData, setRevenueByCountryData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })
  const [comparisonRevenueByCountryData, setComparisonRevenueByCountryData] =
    useState({
      labels: [],
      datasets: [
        {
          label: "",
          data: [],
        },
      ],
    })
  const [mostRevenueByCategory, setMostRevenueByCategory] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })
  const [
    comparisonMostRevenueByCategory,
    setComparisonMostRevenueByCategory,
  ] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
      },
    ],
  })

  const [totalOrders, setTotalOrders] = useState(null)

  const [netSalesSeries, setNetSalesSeries] = useState([])
  const [totalSales, setTotalSales] = useState(null)

  const [netPaymentSeries, setNetPaymentSeries] = useState([])
  const [totalPayment, setTotalPayment] = useState(null)

  const [discountSeries, setDiscountSeries] = useState([])
  const [totalDiscount, setTotalDiscount] = useState(null)
  const [totalItemsSold, setTotalItemsSold] = useState(null)

  const [orderTypeSeries, setOrderTypeSeries] = useState([])
  const [itemsSold, setItemsSold] = useState([])

  const [hourlySalesData, setHourlySalesData] = useState({})
  const [barOptions, setBarOptions] = useState({
    scales: {
      x: {
        barPercentage: 0.4,
      },
      y: {},
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  })

  // Dates are European numbers (weak direction). In RTL, Arabic "إلى" becomes
  // the first strong character and jumps to the right of both dates. Force an
  // LTR embedding and mark each date as LTR so the connector stays in between.
  const LRM = "\u200E"
  const LRE = "\u202A"
  const PDF = "\u202C"

  const formatDateRangeText = (start, end) =>
    `${LRE}${LRM}${start} ${props.t("to")} ${LRM}${end}${PDF}`

  const formatDateRangeLabel = (start, end) => (
    <span className="dashboard-pie-period-range" dir="ltr">
      <span className="dashboard-pie-period-date" dir="ltr">
        {String(start ?? "")}
      </span>
      <span className="dashboard-pie-period-to">{props.t("to")}</span>
      <span className="dashboard-pie-period-date" dir="ltr">
        {String(end ?? "")}
      </span>
    </span>
  )

  const pieChartDateRange =
    commonDayType === "custom" ? customDateRange : dateRange

  const renderPeriodCaption = (start, end, dayValue) => (
    <p className="fw-bold dashboard-pie-period-caption" dir="ltr">
      {commonDayType === "day"
        ? dayValue
        : (commonDayType === "week" ||
            commonDayType === "month" ||
            commonDayType === "custom") &&
          formatDateRangeLabel(start, end)}
    </p>
  )

  const localizeSeriesTitle = title => {
    if (!title || typeof title !== "string") return title
    const match = title.match(
      /^(\d{4}-\d{2}-\d{2}(?:\s+\d{2}:\d{2})?)\s+to\s+(\d{4}-\d{2}-\d{2}(?:\s+\d{2}:\d{2})?)([\s\S]*)$/
    )
    if (!match) return title
    const [, start, end, suffix] = match
    return `${formatDateRangeText(start, end)}${suffix}`
  }

  function mapSeriesData(series) {
    return series?.map(item => ({
      name: localizeSeriesTitle(item?.name),
      data: item?.data?.map(value =>
        typeof value === "number" ? Number(value?.toFixed(2)) : value
      ),
    }))
  }

  // Backend appends ":pickup/:delivery/:curbside" (or Arabic equivalents) to series names.
  // Translate only the order-type suffix so legends match i18n.
  const ORDER_TYPE_LABEL_KEYS = {
    pickup: "pickup",
    delivery: "delivery",
    curbside: "curbside",
    PICKUP: "pickup",
    DELIVERY: "delivery",
    CURBSIDE: "curbside",
    يلتقط: "pickup",
    التوصيل: "delivery",
    الرصيف: "curbside",
  }

  function mapOrderTypeSeriesData(series) {
    return series?.map(item => {
      const rawName = item?.name || ""
      const sep = rawName.lastIndexOf(":")
      let name = rawName
      if (sep !== -1) {
        const prefix = localizeSeriesTitle(rawName.slice(0, sep))
        const orderType = rawName.slice(sep + 1)
        const key = ORDER_TYPE_LABEL_KEYS[orderType] || orderType
        name = `${prefix}:${props.t(key)}`
      } else {
        name = localizeSeriesTitle(rawName)
      }
      return {
        name,
        data: item?.data?.map(value =>
          typeof value === "number" ? Number(value?.toFixed(2)) : value
        ),
      }
    })
  }

  // Function to calculate sum of data
  function calculateSum(series) {
    let sum = 0
    series.forEach(item => {
      sum += item.data.reduce((acc, curr) => acc + curr, 0)
    })
    return sum
  }

  const backgroundColor = [
    "#008ffb",
    "#00e396",
    "#feb019",
    "#ff4560",
    "#775dd0",
    "#008ffb",
    "#00e396",
    "#feb019",
    "#ff4560",
    "#775dd0",
  ]

  const mergeArrays = (arr1, arr2) => {
    return [...arr1, ...arr2]
  }

  useEffect(() => {
    // Check if dashboardData exists and has the necessary structure
    if (
      dashboardData &&
      dashboardData.mainData &&
      dashboardData.mainData.orders &&
      dashboardData.mainData.orders.series
    ) {
      const categories = dashboardData?.mainData?.categories
      const timesLocalCategories =
        periodType === "day"
          ? convertTimesArrayToLocale(categories)
          : convertDatesArrayToLocale(categories)

      setOptions(prevOptions => ({
        ...prevOptions,
        xaxis: {
          ...prevOptions.xaxis,
          categories: timesLocalCategories,
          type: "category",
        },
      }))

      // ________________MERGE TOTAL ORDERS AND AOV SERIES________________
      const mainOrders = mapSeriesData(dashboardData?.mainData?.orders?.series)
      const mainAOV = mapSeriesData(dashboardData?.mainData?.aovSales?.series)

      const comparisonOrders = mapSeriesData(
        dashboardData?.comparisonData?.orders?.series
      )
      const comparisonAOV = mapSeriesData(
        dashboardData?.comparisonData?.aovSales?.series
      )

      let mergedOrderAOV = []

      if (isCompared) {
        const main = mergeArrays(mainOrders, comparisonOrders)
        const aov = mergeArrays(mainAOV, comparisonAOV)
        mergedOrderAOV = [
          ...main.map(item => ({
            name: `${item.name} - ${props.t("Orders")}`,
            data: item.data,
          })),
          ...aov.map(item => ({
            name: `${item.name} - ${props.t("AOV")}`,
            data: item.data,
          })),
        ]
      } else {
        mergedOrderAOV = [
          ...mainOrders.map(item => ({
            name: `${item.name} - ${props.t("Orders")}`,
            data: item.data,
          })),
          ...mainAOV.map(item => ({
            name: `${item.name} - ${props.t("AOV")}`,
            data: item.data,
          })),
        ]
      }

      setOrderSeries(mergedOrderAOV)

      // ________________GET ITEM SOLD SERIES________________
      const mainItemsSoldSeries = mapSeriesData(
        dashboardData?.mainData?.itemsSold?.series
      )
      const comparisonItemSoldSeries = mapSeriesData(
        dashboardData?.comparisonData?.itemsSold?.series
      )

      const updatedItemsSoldSeries = isCompared
        ? mergeArrays(mainItemsSoldSeries, comparisonItemSoldSeries)
        : mainItemsSoldSeries

      setItemsSold(updatedItemsSoldSeries)
      // ________________GET SALES SERIES________________
      const mainSalesSeries = mapSeriesData(
        dashboardData?.mainData?.sales?.series
      )
      const comparisonSalesSeries = mapSeriesData(
        dashboardData?.comparisonData?.sales?.series
      )

      const updatedSalesSeries = isCompared
        ? mergeArrays(mainSalesSeries, comparisonSalesSeries)
        : mainSalesSeries

      setNetSalesSeries(updatedSalesSeries)

      // ________________GET NET REVENUE SERIES________________
      const mainPaymentSeries = mapSeriesData(
        dashboardData?.mainData?.revenue?.series
      )
      const comparisonPaymentSeries = mapSeriesData(
        dashboardData?.comparisonData?.revenue?.series
      )

      const updatedPaymentSeries = isCompared
        ? mergeArrays(mainPaymentSeries, comparisonPaymentSeries)
        : mainPaymentSeries

      setNetPaymentSeries(updatedPaymentSeries)

      // ________________GET DISCOUNT SERIES________________
      const mainDiscountSeries = mapSeriesData(
        dashboardData?.mainData?.discount?.series
      )
      const comparisonDiscountSeries = mapSeriesData(
        dashboardData?.comparisonData?.discount?.series
      )
      const updatedDiscountSeries = isCompared
        ? mergeArrays(mainDiscountSeries, comparisonDiscountSeries)
        : mainDiscountSeries

      setDiscountSeries(updatedDiscountSeries)

      // ________________GET ORDER TYPE SERIES________________
      const mainOrderTypeSeries = mapOrderTypeSeriesData(
        dashboardData?.mainData?.orderTypes?.series
      )
      const comparisonOrderTypeSeries = mapOrderTypeSeriesData(
        dashboardData?.comparisonData?.orderTypes?.series
      )

      const updatedOrderTypeSeries = isCompared
        ? mergeArrays(mainOrderTypeSeries, comparisonOrderTypeSeries)
        : mainOrderTypeSeries

      setOrderTypeSeries(updatedOrderTypeSeries)

      // ________________CALCULATE TOTAL ORDERS________________
      const orderSum = calculateSum(dashboardData?.mainData?.orders?.series)
      setTotalOrders(orderSum)

      // ________________CALCULATE TOTAL SALES________________
      const salesSum = calculateSum(dashboardData?.mainData?.sales?.series)
      setTotalSales(salesSum)

      // ________________CALCULATE TOTAL NET PAYMENT________________
      const paymentSum = calculateSum(dashboardData?.mainData?.revenue?.series)
      setTotalPayment(paymentSum)

      // ________________CALCULATE TOTAL DISCOUNT________________
      const discountSum = calculateSum(
        dashboardData?.mainData?.discount?.series
      )
      setTotalDiscount(discountSum)
      // ________________CALCULATE TOTAL ITEMS SOLD________________
      const itemsSoldSum = calculateSum(
        dashboardData?.mainData?.itemsSold?.series
      )
      setTotalItemsSold(itemsSoldSum)

      // ________________REVENUE BY CATEGORY________________
      const revenueByCategoryLabels =
        dashboardData?.mainData?.pieChartData?.mostUsedCategories?.map(item =>
          language === "sa" ? item.nameAr : item.name
        )

      const revenueByCategoryData =
        dashboardData?.mainData?.pieChartData?.mostUsedCategories?.map(
          item => item.amount // or use item.count if needed
        )

      const revenueByCategoryCounts =
        dashboardData?.mainData?.pieChartData?.mostUsedCategories?.map(
          item => item.count
        )

      setMostRevenueByCategory(prevOptions => ({
        ...prevOptions,
        labels: revenueByCategoryLabels,
        datasets: [
          {
            label: "",
            data: revenueByCategoryData,
            backgroundColor: backgroundColor,
            counts: revenueByCategoryCounts,
          },
        ],
      }))

      const comparisonRevenueByCategoryLabels =
        dashboardData?.comparisonData?.pieChartData?.mostUsedCategories?.map(
          item => (language === "sa" ? item.nameAr : item.name)
        )
      const comparisonRevenueByCategoryData =
        dashboardData?.comparisonData?.pieChartData?.mostUsedCategories?.map(
          item => item.amount
        )
      const comparisonRevenueByCategoryCounts =
        dashboardData?.comparisonData?.pieChartData?.mostUsedCategories?.map(
          item => item.count
        )

      setComparisonMostRevenueByCategory(prevOptions => ({
        ...prevOptions,
        labels: comparisonRevenueByCategoryLabels,
        datasets: [
          {
            label: "",
            data: comparisonRevenueByCategoryData,
            backgroundColor: backgroundColor,
            counts: comparisonRevenueByCategoryCounts,
          },
        ],
      }))

      // ________________MOST ORDERS BRANCH________________

      const mostOrderedOrderLabels =
        dashboardData?.mainData?.pieChartData?.mostOrderedBranch?.map(item =>
          language === "sa" ? item.nameAr : item.name
        )

      const mostOrderedBranchSeries =
        dashboardData?.mainData?.pieChartData?.mostOrderedBranch?.map(
          item => item.amount
        )

      const mostOrderedBranchCounts =
        dashboardData?.mainData?.pieChartData?.mostOrderedBranch?.map(
          item => item.count
        )

      setOrderBranchData(prevOptions => ({
        ...prevOptions,
        labels: mostOrderedOrderLabels,
        datasets: [
          {
            label: "",
            data: mostOrderedBranchSeries,
            backgroundColor: backgroundColor,
            counts: mostOrderedBranchCounts,
          },
        ],
      }))

      const mostComparisonOrderedOrderLabels =
        dashboardData?.comparisonData?.pieChartData?.mostOrderedBranch?.map(
          item => (language === "sa" ? item.nameAr : item.name)
        )

      const mostComparisonOrderedBranchSeries =
        dashboardData?.comparisonData?.pieChartData?.mostOrderedBranch?.map(
          item => item.amount
        )
      const mostComparisonOrderedBranchCounts =
        dashboardData?.comparisonData?.pieChartData?.mostOrderedBranch?.map(
          item => item.count
        )
      setComparisonOrderBranchData(prevOptions => ({
        ...prevOptions,
        labels: mostComparisonOrderedOrderLabels,
        datasets: [
          {
            label: "",
            data: mostComparisonOrderedBranchSeries,
            backgroundColor: backgroundColor,
            counts: mostComparisonOrderedBranchCounts,
          },
        ],
      }))

      // ________________REVENUE BY COUNTRY________________
      const revenueByCountryLabels =
        dashboardData?.mainData?.pieChartData?.revenueByCountry?.map(item =>
          language === "sa" ? item.nameAr : item.name
        )

      const revenueByCountryData =
        dashboardData?.mainData?.pieChartData?.revenueByCountry?.map(
          item => item.amount // or use item.count if needed
        )

      const revenueByCountryCounts =
        dashboardData?.mainData?.pieChartData?.revenueByCountry?.map(
          item => item.count
        )

      setRevenueByCountryData(prevOptions => ({
        ...prevOptions,
        labels: revenueByCountryLabels,
        datasets: [
          {
            label: "", // optional: "Total Revenue" or "Order Count"
            data: revenueByCountryData,
            backgroundColor: backgroundColor,
            counts: revenueByCountryCounts,
          },
        ],
      }))

      const comparisonRevenueByCountryLabels =
        dashboardData?.comparisonData?.pieChartData?.revenueByCountry?.map(
          item => (language === "sa" ? item.nameAr : item.name)
        )
      const comparisonRevenueByCountrySeries =
        dashboardData?.comparisonData?.pieChartData?.revenueByCountry?.map(
          item => item.amount
        )
      const comparisonRevenueByCountryCounts =
        dashboardData?.comparisonData?.pieChartData?.revenueByCountry?.map(
          item => item.count
        )

      setComparisonRevenueByCountryData(prevOptions => ({
        ...prevOptions,
        labels: comparisonRevenueByCountryLabels,
        datasets: [
          {
            label: "",
            data: comparisonRevenueByCountrySeries,
            backgroundColor: backgroundColor,
            counts: comparisonRevenueByCountryCounts,
          },
        ],
      }))

      // ________________MOST ORDER ITEM________________
      const mostOrderedItemsLabels =
        dashboardData?.mainData?.pieChartData?.mostOrderedItems?.map(item =>
          language === "sa" ? item.nameAr : item.name
        )
      const mostOrderedItemAmounts =
        dashboardData?.mainData?.pieChartData?.mostOrderedItems?.map(
          item => item.amount
        )
      const mostOrderedItemCounts =
        dashboardData?.mainData?.pieChartData?.mostOrderedItems?.map(
          item => item.count
        )

      setMostOrderedItemsData(prevOptions => ({
        ...prevOptions,
        labels: mostOrderedItemsLabels,
        datasets: [
          {
            label: "",
            data: mostOrderedItemCounts,
            backgroundColor: backgroundColor,
            amounts: mostOrderedItemAmounts,
          },
        ],
      }))

      const mostComparisonOrderedItemsLabels =
        dashboardData?.comparisonData?.pieChartData?.mostOrderedItems?.map(
          item => (language === "sa" ? item.nameAr : item.name)
        )
      const mostComparisonOrderedItemSeries =
        dashboardData?.comparisonData?.pieChartData?.mostOrderedItems?.map(
          item => item.count
        )
      const mostComparisonOrderedRevenueSeries =
        dashboardData?.comparisonData?.pieChartData?.mostOrderedItems?.map(
          item => item.amount
        )

      setComparisonMostOrderedItemsData(prevOptions => ({
        ...prevOptions,
        labels: mostComparisonOrderedItemsLabels,
        datasets: [
          {
            label: "",
            amounts: mostComparisonOrderedRevenueSeries,
            backgroundColor: backgroundColor,
            data: mostComparisonOrderedItemSeries,
          },
        ],
      }))

      // ________________MOST PAYMENT METHOD________________
      const mostPaymentMethodLabels =
        dashboardData?.mainData?.pieChartData?.mostUsedPaymentMethod?.map(
          item => props.t(item._id)
        )
      const mostPaymentMethodSeries =
        dashboardData?.mainData?.pieChartData?.mostUsedPaymentMethod?.map(
          item => item.count
        )
      setMostPaymentMethodData(prevOptions => ({
        ...prevOptions,
        labels: mostPaymentMethodLabels,
        datasets: [
          {
            label: "",
            data: mostPaymentMethodSeries,
            backgroundColor: backgroundColor,
          },
        ],
      }))
      const mostComparisonPaymentMethodLabels =
        dashboardData?.comparisonData?.pieChartData?.mostUsedPaymentMethod?.map(
          item => props.t(item._id)
        )
      const mostComparisonPaymentMethodSeries =
        dashboardData?.comparisonData?.pieChartData?.mostUsedPaymentMethod?.map(
          item => item.count
        )
      setComparisonMostPaymentMethodData(prevOptions => ({
        ...prevOptions,
        labels: mostComparisonPaymentMethodLabels,
        datasets: [
          {
            label: "",
            data: mostComparisonPaymentMethodSeries,
            backgroundColor: backgroundColor,
          },
        ],
      }))

      // ________________HOURLY SALES________________
      const mainHourlySalesLabel =
        dashboardData?.mainData?.hourlySales?.series[0]?.name
      const MainHourlySalesSeries =
        dashboardData?.mainData?.hourlySales?.series[0]?.data

      const comparisonHourlySalesLabel =
        dashboardData?.comparisonData?.hourlySales?.series[0]?.name
      const comparisonMainHourlySalesSeries =
        dashboardData?.comparisonData?.hourlySales?.series[0]?.data

      const mainHourlySalesData = {
        label: localizeSeriesTitle(mainHourlySalesLabel),
        borderWidth: 1,
        backgroundColor: backgroundColor[0],
        borderColor: backgroundColor[0],
        data: MainHourlySalesSeries,
      }
      const comparisonHourlySalesData = {
        label: localizeSeriesTitle(comparisonHourlySalesLabel),
        borderWidth: 1,
        backgroundColor: backgroundColor[1],
        borderColor: backgroundColor[1],
        data: comparisonMainHourlySalesSeries,
      }

      const hourlyDataSets = isCompared
        ? [mainHourlySalesData, comparisonHourlySalesData]
        : [mainHourlySalesData]

      const timesLocal = convertTimesArrayToLocale(timesUTC)

      setHourlySalesData({
        labels: timesLocal,
        datasets: hourlyDataSets,
      })

      setTimeout(() => {
        setIsLoading(false)
      }, 1500)
    }
  }, [dashboardData, language])

  const [isAllSelected, setIsAllSelected] = useState(false)

  const branchListOptions = branchsList?.map(item => ({
    label: language === "sa" ? item.nameAr : item.name,
    value: item._id,
  }))

  const eidiyahListOptions = useMemo(
    () =>
      giftCardList
        ?.filter(item => item.cardType == categoryId)
        .map(item => ({
          label: language === "sa" ? item.nameAr : item.name,
          value: item._id,
        })),
    [categoryId]
  )

  const giftCardCategories = categories?.map(item => ({
    label: item.cardType,
    value: item._id,
  }))

  const branchOptions = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  const handleBookingReset = () => {
    if (childFunctionRef.current) {
      childFunctionRef.current()
    }
  }

  // console.log({
  //   periodType,
  //   commonDayType,
  //   dateRange,
  //   customDateRange,
  //   commonDateRange,
  // })

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Dashboards")} />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <CardTitle className="fs-4">
                    {props.t("Welcome")}
                  </CardTitle>
                  <Col>
                    <div className="dashboard_top_tabs">
                      <div className="d-flex align-items-center justify-content-between">
                        <ul className="d-flex ps-0 mt-3 mb-2">
                          {usersPermissions.isEidiyah && (
                            <li
                              className={`fs-5 ${
                                tabs === "Gift Card" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("Gift Card")}
                            >
                              {props.t("Gift Card")}
                            </li>
                          )}
                          {usersPermissions.isSales && (
                            <li
                              className={`fs-5 ${
                                tabs === "sales" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("sales")}
                            >
                              {props.t("Sales")}
                            </li>
                          )}
                          {usersPermissions.isBranches && (
                            <li
                              className={`fs-5  ${
                                tabs === "branches" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("branches")}
                            >
                              {props.t("Branches")}
                            </li>
                          )}
                          {usersPermissions.isRatings && (
                            <li
                              className={`fs-5  ${
                                tabs === "ratings" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("ratings")}
                            >
                              {props.t("Ratings")}
                            </li>
                          )}
                          {usersPermissions.isBookings && (
                            <li
                              className={`fs-5 ${
                                tabs === "bookings" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("bookings")}
                            >
                              {props.t("Bookings")}
                            </li>
                          )}
                          {usersPermissions.isWallet && (
                            <li
                              className={`fs-5 ${
                                tabs === "wallet" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("wallet")}
                            >
                              {props.t("Wallet")}
                            </li>
                          )}
                          {usersPermissions.isEstore && (
                            <li
                              className={`fs-5 ${
                                tabs === "estore" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("estore")}
                            >
                              {props.t("E-Store")}
                            </li>
                          )}
                          {usersPermissions.isMarketing && (
                            <li
                              className={`fs-5 ${
                                tabs === "marketing" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("marketing")}
                            >
                              {props.t("Marketing")}
                            </li>
                          )}
                          {usersPermissions.isLoyalty && (
                            <li
                              className={`fs-5 ${
                                tabs === "loyalty" ? "active" : ""
                              }`}
                              onClick={() => handleTabClick("loyalty")}
                            >
                              {props.t("Loyalty Points")}
                            </li>
                          )}
                        </ul>
                      </div>
                    </div>
                  </Col>
                  {tabs === "sales" ||
                  tabs === "estore" ||
                  tabs === "marketing" ||
                  tabs === "loyalty" ? null : (
                    <Col className="mt-3">
                      <div className="dashboard-filter-bar d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center justify-content-between gap-3">
                        <div className="dashboard-filter-bar__date">
                        <CommonDateFilter
                          isLoading={isLoading}
                          date={date}
                          commonDateRange={commonDateRange}
                          setCommonDateRange={handleCommonDateRangeChange}
                          formattedToday={formattedToday}
                          formattedStartOfCurrentWeek={
                            formattedStartOfCurrentWeek
                          }
                          formattedEndOfCurrentWeek={formattedEndOfCurrentWeek}
                          formattedStartOfMonth={formattedStartOfMonth}
                          formattedEndOfMonth={formattedEndOfMonth}
                          formattedYesterday={formattedYesterday}
                          formatDate={formatDate}
                          commonDayType={commonDayType}
                          setCommonDayType={handleCommonDayTypeChange}
                          t={props.t}
                        />
                        </div>
                        {tabs === "ratings" && (
                          <div className="dashboard-filter-bar__branch">
                            <Select
                              value={ratingBranches}
                              isMulti={true}
                              onChange={item => {
                                if (
                                  item?.find(option => option.value === "*")
                                ) {
                                  setRatingBranches(branchListOptions)
                                  setIsAllSelected(true)
                                } else {
                                  setRatingBranches(item)
                                  setIsAllSelected(
                                    item.length === branchListOptions.length
                                  )
                                }
                              }}
                              options={branchOptions}
                              placeholder={props.t("Select Branches")}
                              closeMenuOnSelect={false}
                              {...DASHBOARD_SELECT_MENU_PROPS}
                              styles={dashboardSelectMenuStyles}
                            />
                          </div>
                        )}

                        {/* Add Filter for the categories  hello world*/}

                        {tabs === "Gift Card" && (
                          <div className="dashboard-filter-bar__select me-lg-2">
                            <Select
                              value={giftCardCategories.find(
                                option => option.value == categoryId
                              )}
                              isClearable
                              onChange={item => {
                                setCategoryId(item?.value)
                                setGiftCardId([])
                                setIsAllSelected(false)
                              }}
                              options={giftCardCategories}
                              placeholder={props.t(
                                "Select Gift Card Categories"
                              )}
                            />
                          </div>
                        )}

                        {tabs === "Gift Card" && (
                          <div className="dashboard-filter-bar__select">
                            <Select
                              isDisabled={!categoryId}
                              value={giftCardId}
                              isMulti={true}
                              styles={giftCardListSelectStyles}
                              onChange={item => {
                                if (
                                  item?.find(option => option.value === "*")
                                ) {
                                  setGiftCardId(eidiyahListOptions)
                                  setIsAllSelected(true)
                                } else {
                                  setGiftCardId(item)
                                  setIsAllSelected(
                                    item.length === eidiyahListOptions.length
                                  )
                                }
                              }}
                              options={eidiyahListOptions}
                              placeholder={props.t("Select Gift Card Lists")}
                              closeMenuOnSelect={false}
                              noOptionsMessage={() => props.t("No options")}
                            />
                          </div>
                        )}

                        {tabs === "bookings" && (
                          <div className="d-flex align-items-center justify-content-between mt-3">
                            <button
                              className="g_center"
                              style={{
                                background: "transparent",
                                borderRadius: 8,
                                minWidth: 40,
                                height: 40,
                                border: "1px solid #556ee6",
                              }}
                            >
                              <i
                                onClick={() => setBookingModal(!bookingModal)}
                                className="bx bxs-filter-alt fs-4"
                                style={{ color: "#556ee6" }}
                              ></i>
                              {bookingType && bookingType.length > 0 && (
                                <i
                                  className="mdi mdi-close-circle-outline fs-4"
                                  style={{
                                    color: "rgb(148, 151, 167)",
                                    marginLeft: 5,
                                  }}
                                  onClick={() => {
                                    setBookingType([])
                                    handleBookingReset()
                                  }}
                                ></i>
                              )}
                            </button>
                          </div>
                        )}

                        {tabs === "branches" && (
                          <button
                            className="g_center"
                            style={{
                              background: "transparent",
                              borderRadius: 8,
                              minWidth: 40,
                              height: 40,
                              border: "1px solid #556ee6",
                            }}
                          >
                            <i
                              onClick={toggleModal}
                              className="bx bxs-filter-alt fs-4"
                              style={{ color: "#556ee6" }}
                            ></i>{" "}
                            {(selectedBranches.length > 0 ||
                              Object.keys(selectedCountry).length > 0 ||
                              Object.keys(selectedRegion).length > 0 ||
                              Object.keys(selectedCity).length > 0 ||
                              selectedBrand) && (
                              <i
                                className="mdi mdi-close-circle-outline fs-4"
                                style={{
                                  color: "rgb(148, 151, 167)",
                                  marginLeft: 5,
                                }}
                                onClick={() => {
                                  setSelectedBranches([])
                                  setSelectedCountry([])
                                  setSelectedRegion([])
                                  setSelectedCity([])
                                  setBranches([])
                                  setCountry([])
                                  setRegion([])
                                  setCity([])
                                  setSelectedBrand(null)
                                }}
                              ></i>
                            )}
                          </button>
                        )}
                      </div>
                    </Col>
                  )}

                  {(tabs === "sales" ||
                    tabs === "estore" ||
                    tabs === "marketing" ||
                    tabs === "loyalty") && (
                    <Col>
                      <div className="ms-auto mt-3 ">
                        <div className="d-flex align-items-center justify-content-between">
                          {/* <ul className="nav nav-pills" style={{ minWidth: 220 }}> */}
                          <div className="d-flex align-items-center">
                            <ul
                              className="nav nav-pills"
                              style={{ minWidth: 80 }}
                            >
                              <li className="nav-item">
                                <button
                                  type="button"
                                  className={classNames(
                                    { active: commonDayType === "day" },
                                    {
                                      "disabled-link":
                                        tabs === "estore" ||
                                        tabs === "marketing" ||
                                        tabs === "loyalty"
                                          ? false
                                          : isLoading,
                                    },
                                    "nav-link"
                                  )}
                                  onClick={() => {
                                    if (
                                      tabs === "estore" ||
                                      tabs === "marketing" ||
                                      tabs === "loyalty"
                                    ) {
                                      return onChangeChartPeriod("day", "day")
                                    }

                                    !isLoading &&
                                      onChangeChartPeriod("day", "day")
                                  }}
                                  id="one_month"
                                >
                                  {props.t("Day")}
                                </button>{" "}
                              </li>
                              <li className="nav-item">
                                <button
                                  type="button"
                                  className={classNames(
                                    { active: commonDayType === "week" },
                                    {
                                      "disabled-link":
                                        tabs === "estore" ||
                                        tabs === "marketing" ||
                                        tabs === "loyalty"
                                          ? false
                                          : isLoading,
                                    },
                                    "nav-link"
                                  )}
                                  onClick={() => {
                                    if (
                                      tabs === "estore" ||
                                      tabs === "marketing" ||
                                      tabs === "loyalty"
                                    ) {
                                      return onChangeChartPeriod("week", "week")
                                    }
                                    !isLoading &&
                                      onChangeChartPeriod("week", "week")
                                  }}
                                >
                                  {props.t("Week")}
                                </button>{" "}
                              </li>
                              <li className="nav-item">
                                <button
                                  type="button"
                                  className={classNames(
                                    { active: commonDayType === "month" },
                                    {
                                      "disabled-link":
                                        tabs === "estore" ||
                                        tabs === "marketing" ||
                                        tabs === "loyalty"
                                          ? false
                                          : isLoading,
                                    },
                                    "nav-link"
                                  )}
                                  onClick={() => {
                                    if (
                                      tabs === "estore" ||
                                      tabs === "marketing" ||
                                      tabs === "loyalty"
                                    ) {
                                      return onChangeChartPeriod(
                                        "month",
                                        "month"
                                      )
                                    }
                                    !isLoading &&
                                      onChangeChartPeriod("month", "month")
                                  }}
                                >
                                  {props.t("Month")}
                                </button>{" "}
                              </li>
                              <li className="nav-item">
                                <button
                                  type="button"
                                  className={classNames(
                                    { active: commonDayType === "custom" },
                                    {
                                      "disabled-link":
                                        tabs === "estore" ||
                                        tabs === "marketing" ||
                                        tabs === "loyalty"
                                          ? false
                                          : isLoading,
                                    },
                                    "nav-link"
                                  )}
                                  onClick={() => {
                                    if (
                                      tabs === "estore" ||
                                      tabs === "marketing" ||
                                      tabs === "loyalty"
                                    ) {
                                      return onChangeChartPeriod(
                                        "custom",
                                        "custom"
                                      )
                                    }
                                    !isLoading &&
                                      onChangeChartPeriod("custom", "custom")
                                  }}
                                >
                                  {props.t("Custom")}
                                </button>{" "}
                              </li>
                              {/* SHOW */}

                              <li style={{ maxWidth: 115, marginLeft: 5 }}>
                                {commonDayType === "day" && (
                                  <DatePicker
                                    format="yyyy-MM-dd"
                                    value={new Date(date)}
                                    onChange={value =>
                                      handleOnDateChange(value, "day")
                                    }
                                  />
                                )}
                              </li>

                              <li style={{ maxWidth: 210, marginLeft: 10 }}>
                                {commonDayType === "week" && (
                                  <DateRangePicker
                                    format="yyyy-MM-dd"
                                    value={[
                                      new Date(dateRange.start),
                                      new Date(dateRange.end),
                                    ]}
                                    hoverRange="week"
                                    ranges={[]}
                                    oneTap
                                    isoWeek
                                    onChange={handleDateRangeChange}
                                  />
                                )}
                              </li>
                              <li style={{ maxWidth: 210, marginLeft: 10 }}>
                                {commonDayType === "month" && (
                                  <DateRangePicker
                                    format="yyyy-MM-dd"
                                    value={[
                                      new Date(dateRange.start),
                                      new Date(dateRange.end),
                                    ]}
                                    hoverRange="month"
                                    ranges={[]}
                                    oneTap
                                    isoWeek
                                    onChange={handleDateRangeChange}
                                  />
                                )}
                              </li>

                              <li style={{ maxWidth: 200, marginLeft: 5 }}>
                                {commonDayType === "custom" && (
                                  <DateRangePicker
                                    format={
                                      tabs === "sales"
                                        ? "yyyy-MM-dd HH:mm"
                                        : "yyyy-MM-dd"
                                    }
                                    value={[
                                      new Date(customDateRange.start),
                                      new Date(customDateRange.end),
                                    ]}
                                    ranges={[]}
                                    showMeridian={false}
                                    onChange={handleCustomDateRangeChange}
                                  />
                                )}
                              </li>
                            </ul>
                            {tabs === "estore" ||
                            tabs === "marketing" ||
                            tabs === "loyalty" ? null : commonDayType ===
                              "custom" ? null : (
                              <div className="d-flex align-items-center mx-1">
                                <h6 className="mx-2 mb-0">
                                  {props.t("Compare")}
                                </h6>
                                <Switch
                                  onClickHandler={() =>
                                    setIsCompared(!isCompared)
                                  }
                                  disabled={isLoading}
                                  isChecked={isCompared}
                                />
                              </div>
                            )}
                            {isCompared && commonDayType === "day" && (
                              <div style={{ width: 115, marginLeft: 10 }}>
                                <DatePicker
                                  format="yyyy-MM-dd"
                                  value={new Date(comparisonDate)}
                                  onChange={value =>
                                    handleOnDateChange(value, "comparisonDate")
                                  }
                                />
                              </div>
                            )}
                            {isCompared && commonDayType === "week" && (
                              <div style={{ maxWidth: 210, marginLeft: 10 }}>
                                <DateRangePicker
                                  format="yyyy-MM-dd"
                                  value={[
                                    new Date(comparisonDateRange.start),
                                    new Date(comparisonDateRange.end),
                                  ]}
                                  hoverRange="week"
                                  ranges={[]}
                                  oneTap
                                  isoWeek
                                  onChange={handleComparisonDateRangeChange}
                                />
                              </div>
                            )}
                            {isCompared && commonDayType === "month" && (
                              <div style={{ maxWidth: 210, marginLeft: 10 }}>
                                <DateRangePicker
                                  format="yyyy-MM-dd"
                                  value={[
                                    new Date(comparisonDateRange.start),
                                    new Date(comparisonDateRange.end),
                                  ]}
                                  hoverRange="month"
                                  ranges={[]}
                                  oneTap
                                  isoWeek
                                  onChange={handleComparisonDateRangeChange}
                                />
                              </div>
                            )}
                          </div>

                          {tabs === "sales" && (
                            <button
                              className="g_center"
                              style={{
                                background: "transparent",
                                borderRadius: 8,
                                minWidth: 40,
                                height: 40,
                                border: "1px solid #556ee6",
                              }}
                            >
                              <i
                                onClick={toggleModal}
                                className="bx bxs-filter-alt fs-4"
                                style={{ color: "#556ee6" }}
                              ></i>{" "}
                              {(selectedBranches.length > 0 ||
                                Object.keys(selectedCountry).length > 0 ||
                                Object.keys(selectedRegion).length > 0 ||
                                Object.keys(selectedCity).length > 0) && (
                                <i
                                  className="mdi mdi-close-circle-outline fs-4"
                                  style={{
                                    color: "rgb(148, 151, 167)",
                                    marginLeft: 5,
                                  }}
                                  onClick={() => {
                                    setSelectedBranches([])
                                    setSelectedCountry([])
                                    setSelectedRegion([])
                                    setSelectedCity([])
                                    setBranches([])
                                    setCountry([])
                                    setRegion([])
                                    setCity([])
                                  }}
                                ></i>
                              )}
                            </button>
                          )}
                        </div>
                      </div>
                    </Col>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          {tabs === "estore" && (
            <EStore
              periodType={periodType}
              date={date}
              commonDateRange={
                periodType === "custom" ? customDateRange : dateRange
              }
              hasEstorePermission={usersPermissions.isEstore}
            />
          )}
          {tabs === "marketing" && (
            <Marketing
              periodType={periodType}
              date={date}
              commonDateRange={
                periodType === "custom" ? customDateRange : dateRange
              }
              hasMarketingPermission={usersPermissions.isMarketing}
            />
          )}
          {tabs === "loyalty" && (
            <LoyaltyPoints
              periodType={periodType}
              date={date}
              commonDateRange={
                periodType === "custom" ? customDateRange : dateRange
              }
              hasLoyaltyPermission={usersPermissions.isLoyalty}
            />
          )}

          {tabs === "Gift Card" && (
            <GiftCard
              cardCategoryId={categoryId}
              hasEidiyahPermission={usersPermissions.isEidiyah}
              t={props.t}
              giftCardId={giftCardId}
              dateRange={dateRange}
              commonDayType={commonDayType}
              periodType={periodType}
              customDateRange={customDateRange}
              commonDateRange={commonDateRange}
            />
          )}

          {tabs === "sales" && (
            <>
              <Row>
                <Col sm={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>{`${props.t("Total Orders")} / ${props.t(
                        "Average Order Value"
                      )}`}</CardTitle>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <>
                          <h2>{totalOrders}</h2>
                          <div style={{ direction: "ltr" }}>
                            {orderSeries.length === 0 && isLoading ? (
                              "Loading"
                            ) : (
                              <ReactApexChart
                                key={JSON.stringify(orderSeries)}
                                series={orderSeries}
                                options={options}
                                type="line"
                                height={320}
                                className="apex-charts"
                              />
                            )}
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    <CardBody>
                      <CardTitle className="d-flex align-items-center gap-1">
                        {props.t("Gross Revenue")}{" "}
                        <i
                          className="bx bx-info-circle cursor-pointer"
                          id="grossRevenue"
                        ></i>
                        <UncontrolledTooltip
                          placement="top"
                          target={"grossRevenue"}
                        >
                          {props.t("Including discount and taxes")}
                        </UncontrolledTooltip>
                      </CardTitle>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <>
                          <h2>
                            {parseFloat(totalPayment).toFixed(2)}{" "}
                            {props.t("SAR")}
                          </h2>
                          <div style={{ direction: "ltr" }}>
                            <ReactApexChart
                              key={JSON.stringify(netPaymentSeries)}
                              series={netPaymentSeries}
                              options={options}
                              type="line"
                              height={320}
                              className="apex-charts"
                            />
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    <CardBody>
                      <CardTitle className="d-flex align-items-center gap-1">
                        {props.t("Net Revenue")}{" "}
                        <i
                          className="bx bx-info-circle cursor-pointer"
                          id="netRevenue"
                        ></i>
                      </CardTitle>
                      <UncontrolledTooltip
                        placement="top"
                        target={"netRevenue"}
                      >
                        {props.t("Excluding discount and taxes")}
                      </UncontrolledTooltip>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <>
                          <h2>
                            {parseFloat(totalSales)?.toFixed(2)}{" "}
                            {props.t("SAR")}
                          </h2>
                          <div style={{ direction: "ltr" }}>
                            <ReactApexChart
                              key={JSON.stringify(netSalesSeries)}
                              series={netSalesSeries}
                              options={options}
                              type="line"
                              height={320}
                              className="apex-charts"
                            />
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Total Discount")}</CardTitle>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <>
                          <h2>
                            {parseFloat(totalDiscount)?.toFixed(2)}{" "}
                            {props.t("SAR")}
                          </h2>
                          <div style={{ direction: "ltr" }}>
                            <ReactApexChart
                              key={JSON.stringify(itemsSold)}
                              series={itemsSold}
                              options={options}
                              type="line"
                              height={320}
                              className="apex-charts"
                            />
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={6}>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Items Sold")}</CardTitle>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <>
                          <h2>{parseFloat(totalItemsSold)?.toFixed(2)}</h2>
                          <div style={{ direction: "ltr" }}>
                            <ReactApexChart
                              key={JSON.stringify(discountSeries)}
                              series={discountSeries}
                              options={options}
                              type="line"
                              height={320}
                              className="apex-charts"
                            />
                          </div>
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Order Type")}</CardTitle>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <div style={{ direction: "ltr" }}>
                          <ReactApexChart
                            key={JSON.stringify(orderTypeSeries)}
                            series={orderTypeSeries}
                            options={options}
                            type="line"
                            height={320}
                            className="apex-charts"
                          />
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col lg={12}>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Hourly Sales")}</CardTitle>
                      {isLoading ? (
                        <ShimmerThumbnail height={320} rounded />
                      ) : (
                        <div>
                          <div
                            className="d-flex flex-wrap justify-content-center mb-2"
                            style={{ gap: 16 }}
                          >
                            {(hourlySalesData.datasets || []).map(
                              (dataset, index) => (
                                <span
                                  key={index}
                                  className="d-flex align-items-center"
                                  style={{ gap: 6 }}
                                >
                                  <span
                                    style={{
                                      width: 12,
                                      height: 12,
                                      borderRadius: 2,
                                      backgroundColor:
                                        dataset.backgroundColor ||
                                        backgroundColor[
                                          index % backgroundColor.length
                                        ],
                                    }}
                                  />
                                  <span dir="ltr" style={{ unicodeBidi: "isolate" }}>
                                    {dataset.label}
                                  </span>
                                </span>
                              )
                            )}
                          </div>
                          <div style={{ direction: "ltr" }}>
                            <Bar
                              width={550}
                              height={180}
                              data={hourlySalesData}
                              options={barOptions}
                            />
                          </div>
                        </div>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col lg={4}>
                  <Card style={{ minHeight: 260 }}>
                    <CardBody>
                      <CardTitle>
                        {props.t("Top Revenue-Generating Branches")}
                      </CardTitle>
                      {!isLoading &&
                        renderPeriodCaption(
                          pieChartDateRange.start,
                          pieChartDateRange.end,
                          date
                        )}
                      {isLoading ? (
                        <ShimmerThumbnail height={400} rounded />
                      ) : (
                        <Pie
                          height={260}
                          data={orderBranchData}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                position: "right",
                              },
                              tooltip: {
                                callbacks: {
                                  label: function (tooltipItem) {
                                    // Access the dataset and data
                                    const dataset = tooltipItem?.dataset
                                    const value =
                                      dataset?.data[tooltipItem?.dataIndex] // Get the corresponding value
                                    const count =
                                      dataset?.counts[tooltipItem?.dataIndex] // Access the count from the custom property

                                    // Return the custom tooltip
                                    return [
                                      `${props.t(
                                        "Total Amount"
                                      )} : ${value} SAR`,
                                      `${props.t("Total Orders")}: ${count}`,
                                    ]
                                  },
                                },
                              },
                            },
                          }}
                        />
                      )}
                      {isCompared && (
                        <>
                          {!isLoading &&
                            renderPeriodCaption(
                              comparisonDateRange.start,
                              comparisonDateRange.end,
                              comparisonDate
                            )}
                          {isLoading ? (
                            <ShimmerThumbnail height={400} rounded />
                          ) : (
                            <Pie
                              height={260}
                              data={comparisonOrderBranchData}
                              options={{
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "right",
                                  },
                                },
                              }}
                            />
                          )}
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card style={{ minHeight: 260 }}>
                    <CardBody>
                      <CardTitle>{props.t("Top Ordered Item")}</CardTitle>

                      {!isLoading &&
                        renderPeriodCaption(
                          pieChartDateRange.start,
                          pieChartDateRange.end,
                          date
                        )}

                      {isLoading ? (
                        <ShimmerThumbnail height={400} rounded />
                      ) : (
                        <Pie
                          height={260}
                          data={mostOrderedItemsData}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                position: "right",
                              },
                              tooltip: {
                                callbacks: {
                                  label: function (tooltipItem) {
                                    const dataset = tooltipItem.dataset
                                    const index = tooltipItem.dataIndex

                                    const count = dataset?.data?.[index] ?? 0
                                    const amount =
                                      dataset?.amounts?.[index] ?? 0

                                    return [
                                      `${props.t("Total Orders")} : ${count}`,
                                      `${props.t(
                                        "Total Amount"
                                      )} : ${amount} SAR`,
                                    ]
                                  },
                                },
                              },
                            },
                          }}
                        />
                      )}

                      {isCompared && (
                        <>
                          {!isLoading &&
                            renderPeriodCaption(
                              comparisonDateRange.start,
                              comparisonDateRange.end,
                              comparisonDate
                            )}

                          {isLoading ? (
                            <ShimmerThumbnail height={400} rounded />
                          ) : (
                            <Pie
                              height={260}
                              data={comparisonMostOrderedItemsData}
                              options={{
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "right",
                                  },
                                  tooltip: {
                                    callbacks: {
                                      label: function (tooltipItem) {
                                        const dataset = tooltipItem.dataset
                                        const index = tooltipItem.dataIndex

                                        const count =
                                          dataset?.data?.[index] ?? 0
                                        const amount =
                                          dataset?.amounts?.[index] ?? 0

                                        return [
                                          `${props.t(
                                            "Total Orders"
                                          )} : ${count}`,
                                          `${props.t(
                                            "Total Amount"
                                          )} : ${amount} SAR`,
                                        ]
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                          )}
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>

                <Col lg={4}>
                  <Card style={{ minHeight: 260 }}>
                    <CardBody>
                      <CardTitle>{props.t("Top Payment Method")}</CardTitle>
                      {!isLoading &&
                        renderPeriodCaption(
                          pieChartDateRange.start,
                          pieChartDateRange.end,
                          date
                        )}
                      {isLoading ? (
                        <ShimmerThumbnail height={400} rounded />
                      ) : (
                        <Pie
                          height={260}
                          data={mostPaymentMethodData}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                position: "right",
                              },
                            },
                          }}
                        />
                      )}
                      {isCompared && (
                        <>
                          {!isLoading &&
                            renderPeriodCaption(
                              comparisonDateRange.start,
                              comparisonDateRange.end,
                              comparisonDate
                            )}
                          {isLoading ? (
                            <ShimmerThumbnail height={400} rounded />
                          ) : (
                            <Pie
                              height={260}
                              data={comparisonMostPaymentMethodData}
                              options={{
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "right",
                                  },
                                },
                              }}
                            />
                          )}
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Card style={{ minHeight: 260 }}>
                    <CardBody>
                      <CardTitle>
                        {props.t("Top Revenue-Generating Countries")}
                      </CardTitle>
                      {!isLoading &&
                        renderPeriodCaption(
                          pieChartDateRange.start,
                          pieChartDateRange.end,
                          date
                        )}
                      {isLoading ? (
                        <ShimmerThumbnail height={400} rounded />
                      ) : (
                        <Pie
                          height={260}
                          data={revenueByCountryData}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                position: "right",
                              },
                              tooltip: {
                                callbacks: {
                                  label: function (tooltipItem) {
                                    // Access the dataset and data
                                    const dataset = tooltipItem?.dataset
                                    const value =
                                      dataset?.data[tooltipItem?.dataIndex] // Get the corresponding value
                                    const count =
                                      dataset?.counts[tooltipItem?.dataIndex] // Access the count from the custom property

                                    // Return the custom tooltip
                                    return [
                                      `${props.t(
                                        "Total Amount"
                                      )} : ${value} SAR`,
                                      `${props.t("Total Orders")}: ${count}`,
                                    ]
                                  },
                                },
                              },
                            },
                          }}
                        />
                      )}
                      {isCompared && (
                        <>
                          {!isLoading &&
                            renderPeriodCaption(
                              comparisonDateRange.start,
                              comparisonDateRange.end,
                              comparisonDate
                            )}
                          {isLoading ? (
                            <ShimmerThumbnail height={400} rounded />
                          ) : (
                            <Pie
                              height={260}
                              data={comparisonRevenueByCountryData}
                              options={{
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "right",
                                  },
                                  tooltip: {
                                    callbacks: {
                                      label: function (tooltipItem) {
                                        const dataset = tooltipItem?.dataset
                                        const value =
                                          dataset?.data[tooltipItem?.dataIndex]
                                        const count =
                                          dataset?.counts?.[
                                            tooltipItem?.dataIndex
                                          ]

                                        return [
                                          `${props.t(
                                            "Total Amount"
                                          )} : ${value} SAR`,
                                          `${props.t("Total Orders")}: ${count}`,
                                        ]
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                          )}
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col lg={4}>
                  <Card style={{ minHeight: 260 }}>
                    <CardBody>
                      <CardTitle>
                        {props.t("Top Revenue-Generating Categories")}
                      </CardTitle>
                      {!isLoading &&
                        renderPeriodCaption(
                          pieChartDateRange.start,
                          pieChartDateRange.end,
                          date
                        )}
                      {isLoading ? (
                        <ShimmerThumbnail height={400} rounded />
                      ) : (
                        <Pie
                          height={260}
                          data={mostRevenueByCategory}
                          options={{
                            plugins: {
                              legend: {
                                display: true,
                                position: "right",
                              },
                              tooltip: {
                                callbacks: {
                                  label: function (tooltipItem) {
                                    // Access the dataset and data
                                    const dataset = tooltipItem?.dataset
                                    const value =
                                      dataset?.data[tooltipItem?.dataIndex] // Get the corresponding value
                                    const count =
                                      dataset?.counts[tooltipItem?.dataIndex] // Access the count from the custom property

                                    // Return the custom tooltip
                                    return [
                                      `${props.t(
                                        "Total Amount"
                                      )} : ${value} SAR`,
                                      `${props.t("Total Orders")}: ${count}`,
                                    ]
                                  },
                                },
                              },
                            },
                          }}
                        />
                      )}
                      {isCompared && (
                        <>
                          {!isLoading &&
                            renderPeriodCaption(
                              comparisonDateRange.start,
                              comparisonDateRange.end,
                              comparisonDate
                            )}
                          {isLoading ? (
                            <ShimmerThumbnail height={400} rounded />
                          ) : (
                            <Pie
                              height={260}
                              data={comparisonMostRevenueByCategory}
                              options={{
                                plugins: {
                                  legend: {
                                    display: true,
                                    position: "right",
                                  },
                                  tooltip: {
                                    callbacks: {
                                      label: function (tooltipItem) {
                                        const dataset = tooltipItem?.dataset
                                        const value =
                                          dataset?.data[tooltipItem?.dataIndex]
                                        const count =
                                          dataset?.counts?.[
                                            tooltipItem?.dataIndex
                                          ]

                                        return [
                                          `${props.t(
                                            "Total Amount"
                                          )} : ${value} SAR`,
                                          `${props.t("Total Orders")}: ${count}`,
                                        ]
                                      },
                                    },
                                  },
                                },
                              }}
                            />
                          )}
                        </>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </>
          )}

          {tabs === "branches" && (
            <>
              <Row className="dashboard_count_row">
                <Col>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Active Orders")}</CardTitle>
                      {loading ? (
                        <ShimmerThumbnail
                          height={30}
                          rounded
                          className="mb-0 pb-0"
                        />
                      ) : (
                        <h3>
                          {dashboardOrderData?.cardData?.activeOrdersCount ?? 0}
                        </h3>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Completed Orders")}</CardTitle>
                      {loading ? (
                        <ShimmerThumbnail
                          height={30}
                          rounded
                          className="mb-0"
                        />
                      ) : (
                        <h3>
                          {dashboardOrderData?.cardData?.completedOrdersCount ??
                            0}
                        </h3>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Cancelled Orders")}</CardTitle>
                      {loading ? (
                        <ShimmerThumbnail
                          height={30}
                          rounded
                          className="mb-0"
                        />
                      ) : (
                        <h3>
                          {dashboardOrderData?.cardData?.canceledOrdersCount ??
                            0}
                        </h3>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Active Orders Sales")}</CardTitle>
                      {loading ? (
                        <ShimmerThumbnail
                          height={30}
                          rounded
                          className="mb-0"
                        />
                      ) : (
                        <h3>
                          {dashboardOrderData?.cardData?.activeOrdersAmount ??
                            0}{" "}
                          {props.t("SAR")}
                        </h3>
                      )}
                    </CardBody>
                  </Card>
                </Col>
                <Col>
                  <Card>
                    <CardBody>
                      <CardTitle>{props.t("Completed Orders Sales")}</CardTitle>
                      {loading ? (
                        <ShimmerThumbnail
                          height={30}
                          rounded
                          className="mb-0"
                        />
                      ) : (
                        <h3>
                          {dashboardOrderData?.cardData
                            ?.completedOrdersAmount ?? 0}{" "}
                          {props.t("SAR")}
                        </h3>
                      )}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Card>
                  <CardBody>
                    <CardTitle>{props.t("Branches Statistics")}</CardTitle>
                    <div
                      className="table-responsive"
                      style={{ maxHeight: 600 }}
                    >
                      {loading ? (
                        <TableShimmer row={6} col={7} />
                      ) : dashboardOrderData?.tableData?.length === 0 ? (
                        <p className="text-center my-2">
                          {props.t("No branches data found")}
                        </p>
                      ) : (
                        <Table className="table mb-0 " hover>
                          <thead className="table-light fixed_thead full_th">
                            <tr>
                              <th>{props.t("S. No.")}</th>
                              <th>{props.t("Name")}</th>
                              <th>{props.t("Active Orders Count")}</th>
                              <th>{props.t("Completed Orders Count")}</th>
                              <th>{props.t("Canceled Orders Count")}</th>
                              <th>{props.t("Active Orders Amount")}</th>
                              <th>{props.t("Completed Orders Amount")}</th>
                            </tr>
                          </thead>
                          <tbody style={{ maxHeight: 300 }}>
                            {dashboardOrderData?.tableData?.map(
                              (item, index) => (
                                <tr
                                  key={item._id}
                                  onClick={() => {
                                    navigate(
                                      `/branches/branch-details?id=${item._id}`
                                    )
                                  }}
                                  className="cursor-pointer"
                                >
                                  <td>{index + 1}</td>
                                  <td>
                                    {language === "sa"
                                      ? item.nameAr || item.name
                                      : item.name}
                                  </td>
                                  <td>{item.activeOrdersCount}</td>
                                  <td>{item.completedOrdersCount}</td>
                                  <td>{item.canceledOrdersCount}</td>
                                  <td>
                                    {item.activeOrdersAmount} {props.t("SAR")}
                                  </td>
                                  <td>
                                    {item.completedOrdersAmount}{" "}
                                    {props.t("SAR")}
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Row>
            </>
          )}

          {tabs === "bookings" && (
            <Bookings
              options={options}
              mapSeriesData={mapSeriesData}
              convertTimesArrayToLocale={convertTimesArrayToLocale}
              bookingModal={bookingModal}
              setBookingModal={setBookingModal}
              formatDate={formatDate}
              bookingType={bookingType}
              setBookingType={setBookingType}
              functionRef={childFunctionRef}
              commonDateRange={commonDateRange}
              t={props.t}
              language={language}
              hasBookingsPermission={usersPermissions.isBookings}
            />
          )}

          {tabs === "ratings" && (
            <BranchRatings
              ratingModal={ratingModal}
              setRatingModal={setRatingModal}
              ratingBranches={ratingBranches}
              setRatingBranches={setRatingBranches}
              branchOptions={branchOptions}
              branchListOptions={branchListOptions}
              setIsAllSelected={setIsAllSelected}
              functionRef={ratingFunRef}
              commonDayType={commonDayType}
              commonDateRange={commonDateRange}
              timesUTC={timesUTC}
              convertTimeToUTCDate={convertTimeToUTCDate}
              t={props.t}
              language={language}
              hasRatingsPermission={usersPermissions.isRatings}
            />
          )}

          {tabs === "wallet" && <Wallet commonDateRange={commonDateRange} hasWalletPermission={usersPermissions.isWallet} />}
        </Container>
      </div>

      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>{props.t("Filter")}</ModalHeader>
        <ModalBody>
          <div>
            <Label>{props.t("Select Branches")}</Label>
            <Select
              value={selectedBranches}
              isMulti={true}
              onChange={item => {
                if (item?.find(option => option.value === "*")) {
                  setSelectedBranches(branchListOptions)
                  setIsAllSelected(true)
                } else {
                  setSelectedBranches(item)
                  setIsAllSelected(item.length === branchListOptions.length)
                }
              }}
              options={branchOptions}
              placeholder={props.t("Select Branches")}
              closeMenuOnSelect={false}
            />
          </div>
          {/* <div className="mt-2">
            <Label>{props.t("Select Brand")}</Label>
            <Select
              isClearable
              value={selectedBrand}
              onChange={item => {
                setSelectedBrand(item)
              }}
              options={formattedBrands}
              placeholder={props.t("Select Brand")}
              closeMenuOnSelect={false}
            />
          </div> */}
          <div className="mt-2">
            <Label>{props.t("Select Country")}</Label>
            <Select
              value={selectedCountry}
              onChange={item => {
                setSelectedCountry(item)
                fetchRegionList(item.value)
                setSelectedRegion([])
                setSelectedCity([])
              }}
              options={countryList?.map(item => ({
                label: language === "sa" ? item.nameAr : item.name,
                value: item._id,
              }))}
              className="select2-selection"
              placeholder={props.t("Select Country")}
            />
          </div>
          {Object.keys(selectedCountry)?.length > 0 && (
            <div className="mt-2">
              <Label>{props.t("Select Region")}</Label>
              <Select
                value={selectedRegion}
                onChange={item => {
                  setSelectedRegion(item)
                  fetchCityList(selectedCountry.value, item.value)
                  setSelectedCity([])
                }}
                options={regionList?.map(item => ({
                  label: language === "sa" ? item.nameAr : item.name,
                  value: item._id,
                }))}
                className="select2-selection"
              />
            </div>
          )}
          {Object.keys(selectedRegion)?.length > 0 && (
            <div className="mt-2">
              <Label>{props.t("Select City")}</Label>
              <Select
                value={selectedCity}
                onChange={item => {
                  setSelectedCity(item)
                }}
                options={cityList?.map(item => ({
                  label: language === "sa" ? item.nameAr : item.name,
                  value: item._id,
                }))}
                // placeholder={"Select City"}
                className="select2-selection"
              />
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            {props.t("Cancel")}
          </Button>
          <Button color="primary" onClick={handleBranchFilter}>
            {props.t("Save")}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
